import { render, staticRenderFns } from "./TimerDetails.vue?vue&type=template&id=5872f5d0"
import script from "./TimerDetails.vue?vue&type=script&lang=js"
export * from "./TimerDetails.vue?vue&type=script&lang=js"
import style0 from "./TimerDetails.vue?vue&type=style&index=0&id=5872f5d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports